import moment from "moment-timezone";
import PropTypes from "prop-types";
import "./timezone-autocomplete.scss";
import { Dropdown, Input, Icon } from "semantic-ui-react";

export const TimezoneAutocomplete = ({
  onChange,
  timezoneValue = "America/New_York",
  className = "",
}) => {
  const timezones = moment.tz.names();

  const timezoneOptions = timezones.map((timezone) => {
    const gmtOffset = moment.tz(timezone).format("Z"); // Get the GMT offset
    return {
      key: timezone,
      text: `${timezone} (GMT ${gmtOffset})`, // Format as "timezone (GMT +XX:XX)"
      value: timezone,
    };
  });

  return (
    <div className={`timezone-autocomplete ${className}`.trim()}>
      <Input iconPosition="left" className="timezone-input">
        <Icon name="world" />
        <Dropdown
          placeholder="Select Timezone"
          fluid
          search
          selection
          options={timezoneOptions}
          onChange={(_e, { value }) => onChange(value)}
          value={timezoneValue}
          className="primary button basic"
        />
      </Input>
    </div>
  );
};

TimezoneAutocomplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  timezoneValue: PropTypes.string,
  className: PropTypes.string,
};
